import { createContext } from "react";
import type { UserClaims } from "../utils/oidc";

/**
 * Authentication state and actions exposed to the component tree
 * (conventions/frontend-stack.md: Authentication Context).
 */
export interface AuthContextValue {
  /** Identity parsed from the ID token, or null when not authenticated. */
  user: UserClaims | null;
  /** True when a valid access token is held in memory. */
  isAuthenticated: boolean;
  /** True during the initial check and during a silent renewal. */
  isLoading: boolean;
  /**
   * The current access token, for the API client to attach as a Bearer token.
   * UI components must not read this — they use `isAuthenticated` and `user`.
   */
  accessToken: string | null;
  /** Set when the flow failed, so the UI can explain rather than loop. */
  error: string | null;
  /** True when the KochID environment variables are absent. */
  isConfigured: boolean;
  login: () => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
